module.exports = __webpack_public_path__ + "img/xiaoren.27da5851.png";